import { lodeStarFeeTypeApi, lodeStarFeeTypePricingApi } from 'app/services/api';

import { FeatureFlag } from 'constants/featureFlags';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectFeatureFlagByKey } from 'store/global/selectors';

export const LODE_STAR_FEE_TYPES_ACTION_TYPE = createNamedActions('lodeStarFeeTypes', {
  GET_LODE_STAR_FEE_TYPES: 'GET_LODE_STAR_FEE_TYPES',
  CREATE_LODE_STAR_FEE_TYPE: 'CREATE_LODE_STAR_FEE_TYPE',
  EDIT_LODE_STAR_FEE_TYPE: 'EDIT_LODE_STAR_FEE_TYPE',
  DELETE_LODE_STAR_FEE_TYPE: 'DELETE_LODE_STAR_FEE_TYPE',
});

export const getLodeStarFeeTypesByFeeTypeIdAction = catchAsyncActionError(
  ({ feeTypeId }) =>
    async (dispatch, getState) => {
      const state = getState();
      const isEnabledPricingLodeStarFeeType = selectFeatureFlagByKey(
        FeatureFlag.UseTransferredLodeStarFeeType,
      )(state);

      const { data } = await (isEnabledPricingLodeStarFeeType
        ? lodeStarFeeTypePricingApi.getTypes({ feeTypeId })
        : lodeStarFeeTypeApi.getTypes({ feeTypeId }));

      return dispatch({
        type: LODE_STAR_FEE_TYPES_ACTION_TYPE.GET_LODE_STAR_FEE_TYPES,
        payload: data,
        meta: {
          feeTypeId,
        },
      });
    },
);

export const createLodeStarFeeTypeAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const state = getState();
    const isEnabledPricingLodeStarFeeType = selectFeatureFlagByKey(
      FeatureFlag.UseTransferredLodeStarFeeType,
    )(state);

    const { data } = await (isEnabledPricingLodeStarFeeType
      ? lodeStarFeeTypePricingApi.createType(params)
      : lodeStarFeeTypeApi.createType(params));

    return dispatch({
      type: LODE_STAR_FEE_TYPES_ACTION_TYPE.CREATE_LODE_STAR_FEE_TYPE,
      payload: data,
      meta: {
        feeTypeId: params.feeTypeId,
      },
    });
  },
);

export const editLodeStarFeeTypeAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const state = getState();
    const isEnabledPricingLodeStarFeeType = selectFeatureFlagByKey(
      FeatureFlag.UseTransferredLodeStarFeeType,
    )(state);

    const { feeTypeId, lodeStarFeeTypeId } = params;
    const { data } = await (isEnabledPricingLodeStarFeeType
      ? lodeStarFeeTypePricingApi.editType(params)
      : lodeStarFeeTypeApi.editType(params));

    return dispatch({
      type: LODE_STAR_FEE_TYPES_ACTION_TYPE.EDIT_LODE_STAR_FEE_TYPE,
      payload: data,
      meta: {
        feeTypeId,
        lodeStarFeeTypeId,
      },
    });
  },
);

export const deleteLodeStarFeeTypeAction = catchAsyncActionError(
  params => async (dispatch, getState) => {
    const state = getState();
    const isEnabledPricingLodeStarFeeType = selectFeatureFlagByKey(
      FeatureFlag.UseTransferredLodeStarFeeType,
    )(state);

    const { feeTypeId, lodeStarFeeTypeId } = params;
    const { data } = await (isEnabledPricingLodeStarFeeType
      ? lodeStarFeeTypePricingApi.deleteType(params)
      : lodeStarFeeTypeApi.deleteType(params));

    return dispatch({
      type: LODE_STAR_FEE_TYPES_ACTION_TYPE.DELETE_LODE_STAR_FEE_TYPE,
      payload: data,
      meta: {
        feeTypeId,
        lodeStarFeeTypeId,
      },
    });
  },
);
